import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { IUserConfig } from "src/app/Models/Interface/Auth/user-config";

@Injectable({
  providedIn: "root",
})
export class UserConfigService {
  // @ts-ignore
  public userConfig: BehaviorSubject<IUserConfig> = new BehaviorSubject(null);
  public subject: Observable<IUserConfig> = this.userConfig.asObservable();
  constructor() {}

  setUserConfig(userConfig: IUserConfig): void {
    this.userConfig.next(userConfig);
  }

  getUserConfig(): Observable<IUserConfig> {
    // @ts-ignore
    return this.userConfig.asObservable();
  }
}
